'use strict';

import angular from 'angular';
import modelsModule from '.';
import servicesModule from '../services';
import constants from '../constants';
import currencyResourceModule from '../resources/currency_resource.service';

const localStorageKey = 'currency';
const defaultCurrency = 'EUR';
const currencyModelFactory = ($q, $window, userModel, localStorage, currencyResource, countries) => {
  'ngInject';

  const isLoggedIn = () => Boolean(userModel.item.name);
  const getFromStorage = () => localStorage.get(localStorageKey);
  const saveToStorage = (value) => localStorage.set(localStorageKey, value);
  const getCountryCurrency = (country) => {
    return countries[country] ? countries[country].currency : 'USD';
  };

  return {
    getValue: () => {
      const value = isLoggedIn() ? userModel.getCurrency() :  getFromStorage();
      if(!value && !isLoggedIn()){
        $window.SA = $window.SA || {};
        var currencyByIp = getCountryCurrency($window.SA.country);
        saveToStorage(currencyByIp);
        return currencyByIp;
      }

      return value || defaultCurrency;
    },

    saveValue: (value) => {
      const userId = userModel.item.id;
      $q.resolve(isLoggedIn() && currencyResource.saveCurrency(userId, value))
        .then(() => {
          saveToStorage(value);
          $window.location.reload();
        });
    }
  };
};

const dependencies = [
  modelsModule,
  constants,
  servicesModule,
  currencyResourceModule
];

export default angular
  .module('services.currencyModel', dependencies)
  .factory('currencyModel', currencyModelFactory)
  .name;



// WEBPACK FOOTER //
// ./app/src/models/currency_model.service.js